<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <span class="dc-bar dc-bar--xl"></span>
      <span class="dc-bar dc-bar--lg"></span>
      <div class="dc-body">
        <span class="dc-bar dc-bar--md"></span>
        <span class="dc-bar dc-bar--md"></span>
        <span class="dc-bar dc-bar--sm"></span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewDefaultContent',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.dc-bar {
  display: block; height: 8px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.dc-bar--xl { width: 70%; background: rgba(15, 15, 20, 0.2); }
.dc-bar--lg { width: 55%; }
.dc-bar--md { width: 40%; }
.dc-bar--sm { width: 26%; }
.dc-body { display: flex; flex-direction: column; gap: 6px; margin-top: 4px; }
</style>
